export class SuggestionFilter {
    public query: string;
}


// WEBPACK FOOTER //
// ./src/Models/Filters/SuggestionFilter.ts